import { createContext } from 'react'
import type {
  OrderDateRangePreset,
  PosOrderSource,
  PosOrderSummary,
} from '../../../types'

export interface PosOrderListContextValue {
  storeId: string
  source?: PosOrderSource

  orders: PosOrderSummary[]
  totalItems: number
  isLoading: boolean
  isFetching: boolean
  isError: boolean
  error: unknown

  statusFilter: string
  setStatusFilter: (value: string) => void

  orderTypeFilter: string
  setOrderTypeFilter: (value: string) => void

  locationFilter: string
  setLocationFilter: (value: string) => void

  dateRangePreset: OrderDateRangePreset
  setDateRangePreset: (value: OrderDateRangePreset) => void

  keyword: string
  setKeyword: (value: string) => void

  onSelectOrder?: (orderId: string) => void

  currentPage: number
  totalPages: number
  limit: number
  canGoBack: boolean
  canGoNext: boolean
  showingStart: number
  showingEnd: number
  goToPrevPage: () => void
  goToNextPage: () => void
  goToPage: (page: number) => void
  setLimit: (limit: number) => void
}

export const PosOrderListContext =
  createContext<PosOrderListContextValue | null>(null)
